var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#2F80ED",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3332 7.66646L16.2188 9.55208M6 17.9996L6.03163 17.7782C6.14357 16.9946 6.19954 16.6028 6.32686 16.237C6.43983 15.9125 6.59416 15.6038 6.78604 15.3187C7.00228 14.9974 7.28213 14.7175 7.84183 14.1578L15.6072 6.39248C16.1279 5.87178 16.9721 5.87178 17.4928 6.39248C18.0135 6.91318 18.0135 7.7574 17.4928 8.27809L9.58496 16.1859C9.0772 16.6937 8.82331 16.9476 8.53413 17.1495C8.27745 17.3287 8.00062 17.4771 7.70932 17.5918C7.38114 17.721 7.02917 17.792 6.32529 17.934L6 17.9996Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.5d14f45e139dff191e0781dcbec407f3.svg";
export { ForwardRef as ReactComponent };